import React, { } from 'react'
import { useTranslation } from 'react-i18next'
import { CounterTitle, HorizontalFormWrapper } from '../dashboard.styled'
import { DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import { Button, Cascader, Form, Input, Select } from 'antd'

function CustomSetting (props) {
  const { defPlaceholder, counter, handleDelCounter, handleAddCounter, crossData, crossDataSchema, schema } = props
  const { t: ln_t } = useTranslation()

  const selectorProps = { options: crossData ? crossDataSchema : schema, showSearch: true, placeholder: defPlaceholder('column', 'select') }
  return (
    <>
      {counter?.map(key => (
        <React.Fragment key={key}>
          <CounterTitle>
            {ln_t('dashboard.column')} #{key}
            {counter.length > 1 ? <DeleteTwoTone style={{ cursor: 'pointer' }} twoToneColor="#707070" onClick={() => handleDelCounter(key)} /> : ''}
          </CounterTitle>
          <HorizontalFormWrapper>
            <Form.Item name={`${key}-column`} rules={[{ required: true, message: defPlaceholder('column', 'select') }]}>
              {crossData
                ? <Cascader {...selectorProps} expandTrigger='hover' />
                : <Select {...selectorProps} optionFilterProp="children" />}
            </Form.Item>
            <Form.Item name={`${key}-rename`} rules={[{ required: false, message: defPlaceholder('rename', 'input') }]}>
              <Input placeholder={defPlaceholder('rename', 'input')} />
            </Form.Item>
          </HorizontalFormWrapper>
        </React.Fragment>
      ))}
      <Button type="default" style={{ width: '100%', marginTop: '8px' }} icon={<PlusOutlined />} onClick={handleAddCounter}>
        {ln_t('util.add')} {ln_t('dashboard.custom')}
      </Button>
    </>
  )
}

export default CustomSetting
